module.exports = __webpack_public_path__ + "img/newton-4.db1eaf68.jpg";